export default __webpack_public_path__ + "static/enterprize-header-15bbf945f4dbc252be52ae63e258ab2e.jpg";